module.exports = __webpack_public_path__ + "img/hjc.2b7de9c3.png";